<template>
    <div class="">
        <div class="col-10 mx-auto mt-5 mb-2 pl-3">
            <p class="p-3 mb-0 text-left fts-18" style="font-weight: 900; color: #262A3E;">Historique des versements par titre</p>
        </div>
        <div class="col-10 mx-auto justify-content-center">
            <canvas ref="chart"></canvas>
        </div>
        <div class="col-10 mx-auto mb-4">                           
            <select                                
                class="form-control-2"
                v-model="isin"      
                :name="isin"                           
                @change="onIsinChange">                                    
                <option value="" disabled>Nom</option>
                <option v-for="isi in isis" :key="isi.id" :value="isi">{{ isi.name }}</option>   
            </select>                    
        </div>
    </div>
</template>

<script>
    import {Chart} from 'chart.js';
    export default{
        props:[
            'history_isins',
        ],

        data() {
            return {                                               
                testGraph: null,
                isin: this.history_isins[0],    
                isis: [],                            
            }                      
        },
        mounted() {    
            var ctx = this.$refs.chart.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,1)');
            gradient.addColorStop(0.5, 'rgba(56, 103, 214,0.5)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0)');

            this.history_isins.forEach(history_isin =>
            {
                if (!this.isis.find(element => element.isin == history_isin.isin))
                {                    
                    this.isis.push(history_isin);
                }    
            });

            Chart.defaults.global.defaultFontFamily = 'Lato';
            Chart.defaults.global.defaultFontColor = 'rgb(56, 103, 214)';
            Chart.defaults.global.defaultFontStyle = 'bold';
            Chart.defaults.global.tooltips.enabled = false;

            this.testGraph = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Versements',
                            data: [],
                            fill: true,
                            backgroundColor: gradient,
                            fontFamily: "Lato",
                        },
                    ],
                },
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    tooltips: {
                            enabled: true,
                            titleFontFamily: 'Lato',
                            titleFontStyle: 'normal',
                            titleMarginBottom:10,
                            bodyFontFamily: 'Lato',
                            titleSpacing: 4,
                            bodySpacing:10,
                            titleAlign:'center',
                            bodyFontSize: 12,
                            titleFontSize:12,
                            bodyAlign:'center',
                            custom: function(tooltip) {
                            if (!tooltip) return;
                            // disable displaying the color box;
                            tooltip.displayColors = false;
                            },
                            callbacks: {
                            title: function() {}
                                }
                        },
                    legend: {
                        display:false,
                            labels: {
                                fontFamily: 'Lato',
                                boxWidth:10,
                                fontSize:10
                            },
                            position:'bottom'
                        },
                    scales: {
                        yAxes:[
                            {
                                stacked: false,
                                ticks: {
                                    userCallback: function(value, index, values) {
                                    value = value.toString();
                                    value = value.split(/(?=(?:...)*$)/);
                                    value = value.join(' ');
                                    return value + " " + "€";
                                    },
                                    // Include a euro sign in the ticks
                                    callback: function(value, index, values) {
                                    return value + " " + '€';
                                    },
                                    beginAtZero: true,
                                    fontFamily: "Lato",
                                    fontColor: 'rgb(169,169,169)',
                                    fontSize: 10,
                                    padding:10
                                },
                                gridLines: {
                                    offsetGridLines: false,
                                    display:true,
                                    drawTicks:false,
                                    drawOnChartArea:false,
                                },
                            }
                        ],
                        xAxes:[
                            {
                                ticks: {
                                    fontFamily: "Lato",
                                    fontColor: 'rgb(56, 103, 214)',
                                    fontSize: 10,
                                    padding:20,
                                    fontStyle: 'bold'
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:true,
                                    drawTicks:false,
                                    drawOnChartArea:false,
                                },
                                stacked: false,
                            }
                        ]
                    }
                }
            });
            this.onIsinChange();
        },
        methods: { 
            onIsinChange(){    
                // ici, affichage du graphe en fonction de l'isin selectionné

                var labels = [];
                var prices = [];
                var isi = [];
        
                this.history_isins.forEach(history_isin => {
                    console.log('history_isin' + history_isin.isin)
                    console.log('isin' + this.isin.isin)
                    if (history_isin.isin == this.isin.isin)
                    {
                        labels.push(history_isin.date_point);
                        prices.push(Math.round(history_isin.sum));
                    }             
                });     
                
                console.log('prices' + prices)
                this.testGraph.data.labels = labels;
                this.testGraph.data.datasets[0].data = prices;
                this.testGraph.update();
            },  
                       
        }
    }  
    function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
</script>